import { descriptionId } from "@rjsf/utils";
import apiClient, { apiSendFileHeader } from "../../../../../services/apiClient";


// Функция для преобразования данных из модели сервера в форму
const prepareDataFromServer = (serverData) => {
  return {
    // Основная информация
    type: serverData.type || 'Дошкільний підрозділ',
    ownership: serverData.property || 'Комунальний',
    specialization: serverData.specialization || 'Без спеціалізації',
    extra: serverData.existence?.join(', ') || 'Музичний зал',
    specifics: serverData.specifics || '',
    additionalServices: serverData.additionalServices?.entity || '',
    
    // Контакты
    address: serverData.contacts?.address?.string || 'м. Київ, вул. Лесі Українки, 91А',
    district: serverData.contacts?.address?.district || 'Святошинський',
    phone: serverData.contacts?.phones?.[0] || '(098) 560-60-88',
    email: serverData.contacts?.email || 'dytyachysadochok@osvita.kyivcity.ua',
    site: serverData.contacts?.site || 'https://osvita.kyivcity.gov.ua/dytyachysadochok',
    description: serverData.description,
    
    // Режим работы
    workModes: serverData.workingHours ? [
      {
        mode: serverData.workingHours.type || 'Повний 12-годинний день',
        start: serverData.workingHours.timeFrom || '7:00',
        end: serverData.workingHours.timeTo || '19:00'
      }
    ] : [
      { mode: 'Повний 12-годинний день', start: '7:00', end: '19:00' },
      { mode: 'Скорочений 10,5-годинний день', start: '8:00', end: '18:00' }
    ],
    
    workDays: {
      monday: serverData.workingHours?.daysOfWeek?.includes('monday') ?? true,
      tuesday: serverData.workingHours?.daysOfWeek?.includes('tuesday') ?? true,
      wednesday: serverData.workingHours?.daysOfWeek?.includes('wednesday') ?? true,
      thursday: serverData.workingHours?.daysOfWeek?.includes('thursday') ?? true,
      friday: serverData.workingHours?.daysOfWeek?.includes('friday') ?? true,
      saturday: serverData.workingHours?.daysOfWeek?.includes('saturday') ?? true,
      sunday: serverData.workingHours?.daysOfWeek?.includes('sunday') ?? true
    },
    
    worksOnHolidays: serverData.workingHours?.workAtHolidays ?? true,
    
    // Руководитель (формат: Прізвище Ім'я По батькові) + прив'язка до
    // конкретного працівника (якщо вже обрана раніше).
    manager: serverData.head ? 
      [serverData.head.lastName, serverData.head.firstName, serverData.head.middleName].filter(Boolean).join(' ') 
      : 'Григорович Марія Василівна',
    managerEmployeeId: (serverData.head && serverData.head.employeeId) || null,
    isOpen: serverData.state_open,
    coverDocId:       serverData.coverDocId       || null,
    coverFileId:      serverData.coverFileId      || null,  // оригінал — для майбутнього hero-банера
    coverThumbFileId: serverData.coverThumbFileId || null,  // стиснута версія — для карток
  };
};

// Функция для преобразования данных формы в модель сервера
const prepareDataForServer = (formData) => {
  const workDaysArray = Object.entries(formData.workDays)
    .filter(([_, value]) => value)
    .map(([key]) => key);

  return {
    // Основная информация
    type: formData.type,
    property: formData.ownership,
    specialization: formData.specialization,
    existence: formData.extra ? formData.extra.split(',').map(item => item.trim()) : [],
    description: formData.description,
    specifics: formData.specifics,
    additionalServices: { entity: formData.additionalServices },
    
    // Контакты
    contacts: {
      address: {
        string: formData.address,
        district: formData.district
      },
      phones: [formData.phone],
      email: formData.email,
      site: formData.site
    },
    
    // Режим работы (берем первый режим, так как в модели один режим)
    workingHours: {
      type: formData.workModes[0]?.mode || 'Повний 12-годинний день',
      timeFrom: formData.workModes[0]?.start || '7:00',
      timeTo: formData.workModes[0]?.end || '19:00',
      daysOfWeek: workDaysArray,
      workAtHolidays: formData.worksOnHolidays
    },
    
    // Руководитель (розбираємо ПІБ: Прізвище Ім'я По батькові) + employeeId,
    // якщо директора обрано зі списку працівників.
    head: (() => {
      const [lastName = '', firstName = '', middleName = ''] = formData.manager.trim().split(/\s+/);
      const head = { lastName, firstName, middleName };
      if (formData.managerEmployeeId) { head.employeeId = formData.managerEmployeeId; }
      return head;
    })()
  };
};


const loadPassportData = async (kg_id) => {

    const url = `kindergartens/${kg_id}`;

    const result = await apiClient.get(url);

    if(!result.data || ( result.data.length < 1 ) ) return null;

    return prepareDataFromServer(result.data[0]);
}

const savePassportData = async ({kg_id, data})=>{

    if(!data) return null;
    
    const url = `kindergartens/${kg_id}/main_info`;

    const result = await apiClient.put(url, prepareDataForServer(data));

    return result || null;

}

const setActiveQueueScheduler = async({kg_id, isOpen})=>{

  const url = `kindergartens_state/kindergarten/${kg_id}/${isOpen ? 'set_inactive' : 'set_active'}`;
  
  const result = await apiClient.post(url,{});

  return result;

}

// ── Обкладинка садочка ──────────────────────────────────────────────────────
// Зберігається у двох варіантах: coverFileId (оригінал, для hero-банера)
// і coverThumbFileId (стиснута версія, генерується на бекенді через sharp,
// використовується для карток у сітці пошуку).


function readFileAsBuffer(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload  = function() { resolve(reader.result); };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
    });
}

// Конвертує base64 data URL (з FileUploader, asBase64=true) назад у File
function base64ToFile(dataUrl, filename, mtype) {
    var arr = dataUrl.split(',');
    var mimeMatch = arr[0].match(/:(.*?);/);
    var mime = mtype || (mimeMatch ? mimeMatch[1] : 'application/octet-stream');
    var bstr = atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], filename, { type: mime });
}

const uploadKindergartenCover = async (kg_id, file) => {
    const fileInfo = {
        kg_id:  kg_id,
        name:   file.name,
        mtype:  file.type,
        length: file.size,
        date:   new Date().toISOString(),
    };
    const buffer = await readFileAsBuffer(file);
    const response = await apiSendFileHeader(
        `kindergartens/${kg_id}/cover`,
        buffer,
        fileInfo
    );
    if (!response.ok) throw new Error('Upload failed: ' + response.status);
    const json = await response.json();
    return json.data || json;
};

const deleteKindergartenCover = async (kg_id) => {
    const result = await apiClient.delete(`kindergartens/${kg_id}/cover`);
    return result.data || result;
};

export { 
  loadPassportData, 
  savePassportData, 
  setActiveQueueScheduler, 
  deleteKindergartenCover,
  uploadKindergartenCover,
  base64ToFile
};